import type { TranslationMessages } from '../../types';

export const common: TranslationMessages = {
  add: 'Thêm',
  loading: 'Đang tải...',
  error: 'Lỗi',
  success: 'Thành công',
  warning: 'Cảnh báo',
  info: 'Thông tin',
  retry: 'Thử lại',
  cancel: 'Hủy',
  confirm: 'Xác nhận',
  save: 'Lưu',
  edit: 'Chỉnh sửa',
  delete: 'Xóa',
  view: 'Xem',
  close: 'Đóng',
  back: 'Quay lại',
  next: 'Tiếp theo',
  previous: 'Trước',
  search: 'Tìm kiếm',
  filter: 'Lọc',
  sort: 'Sắp xếp',
  import: 'Nhập',
  refresh: 'Làm mới',
  settings: 'Cài đặt',
  help: 'Trợ giúp',
  support: 'Hỗ trợ',
  logout: 'Đăng xuất',
  profile: 'Hồ sơ',
  dashboard: 'Bảng điều khiển',
  notifications: 'Thông báo',
  messages: 'Tin nhắn',
  no_data: 'Không có dữ liệu',
  no_results: 'Không tìm thấy kết quả',
  try_again: 'Thử lại',
  something_went_wrong: 'Đã xảy ra lỗi',
  please_try_again: 'Vui lòng thử lại',
  access_denied: 'Truy cập bị từ chối',
  insufficient_permissions: 'Không đủ quyền',
  validation_error: 'Lỗi xác thực',
  network_error: 'Lỗi mạng',
  server_error: 'Lỗi máy chủ',
  timeout_error: 'Yêu cầu hết thời gian',
  mobile_optimized: 'Tối ưu hóa cho di động',
  touch_friendly: 'Thân thiện với cảm ứng',
  responsive_design: 'Thiết kế đáp ứng',
  staff: 'Nhân viên',
  dates: 'Ngày',
  status: 'Trạng thái',
  actions: 'Hành động',
  reason: 'Lý do',
  submit: 'Gửi',
  start_date: 'Ngày bắt đầu',
  end_date: 'Ngày kết thúc',
  confirm_delete: 'Bạn có chắc chắn muốn xóa mục này không?',
};
